export function formatSearchType(searchType: string) {
    switch (searchType) {
        case 'for-sale':
            return 'for sale';
        case 'to-rent':
            return 'to rent';
        case 'new-homes':
            return 'for new homes';
        default:
            return 'for sale';
    }
}
